import { globalState } from '@codeleap/store'
import { useEffect } from 'react'

type StoreValue = {
 isFocused: boolean
 isVisible: boolean
}

export const windowStore = globalState<StoreValue>({
  isFocused: true,
  isVisible: true,
})

export function useIsWindowActive() {
  const { isFocused, isVisible } = windowStore.use(s => s)

  useEffect(() => {
    const handleVisibilityChange = () => {
      windowStore.set({ isVisible: !document.hidden })
    }

    const handleFocus = () => {
      windowStore.set({ isFocused: true })
    }

    const handleBlur = () => {
      windowStore.set({ isFocused: false })
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('focus', handleFocus)
    window.addEventListener('blur', handleBlur)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('focus', handleFocus)
      window.removeEventListener('blur', handleBlur)
    }
  }, [])

  return isFocused && isVisible
}

export function getIsWindowActive() {
  const { isFocused, isVisible } = windowStore.get()
  return isFocused && isVisible
}
